module.exports = __webpack_public_path__ + "static/machiner-14673fb0552660383a0d538b72c03816.png";